import * as capSvc from "./services/capService.js";
import {selectRadioBtn, tabKeyCheckbox, tabKeyResumeUpload, tabKeyTextInput} from "../utilities/navigation.js";

const StateProvinces = [
  {
    Id: 1,
    Code: "AL",
    Name: "Alabama"
  },
  {
    Id: 2,
    Code: "AK",
    Name: "Alaska"
  },
  {
    Id: 4,
    Code: "AZ",
    Name: "Arizona"
  },
  {
    Id: 5,
    Code: "AR",
    Name: "Arkansas"
  },
  {
    Id: 7,
    Code: "CA",
    Name: "California"
  },
  {
    Id: 8,
    Code: "CO",
    Name: "Colorado"
  },
  {
    Id: 9,
    Code: "CT",
    Name: "Connecticut"
  },
  {
    Id: 10,
    Code: "DE",
    Name: "Delaware"
  },
  {
    Id: 11,
    Code: "DC",
    Name: "District of Columbia"
  },
  {
    Id: 13,
    Code: "FL",
    Name: "Florida"
  },
  {
    Id: 15,
    Code: "GA",
    Name: "Georgia"
  },
  {
    Id: 16,
    Code: "HI",
    Name: "Hawaii"
  },
  {
    Id: 17,
    Code: "ID",
    Name: "Idaho"
  },
  {
    Id: 18,
    Code: "IL",
    Name: "Illinois"
  },
  {
    Id: 19,
    Code: "IN",
    Name: "Indiana"
  },
  {
    Id: 20,
    Code: "IA",
    Name: "Iowa"
  },
  {
    Id: 21,
    Code: "KS",
    Name: "Kansas"
  },
  {
    Id: 23,
    Code: "KY",
    Name: "Kentucky"
  },
  {
    Id: 24,
    Code: "LA",
    Name: "Louisiana"
  },
  {
    Id: 25,
    Code: "ME",
    Name: "Maine"
  },
  {
    Id: 27,
    Code: "MD",
    Name: "Maryland"
  },
  {
    Id: 28,
    Code: "MA",
    Name: "Massachusetts"
  },
  {
    Id: 29,
    Code: "MI",
    Name: "Michigan"
  },
  {
    Id: 30,
    Code: "MN",
    Name: "Minnesota"
  },
  {
    Id: 31,
    Code: "MS",
    Name: "Mississippi"
  },
  {
    Id: 32,
    Code: "MO",
    Name: "Missouri"
  },
  {
    Id: 33,
    Code: "MT",
    Name: "Montana"
  },
  {
    Id: 34,
    Code: "NE",
    Name: "Nebraska"
  },
  {
    Id: 35,
    Code: "NV",
    Name: "Nevada"
  },
  {
    Id: 37,
    Code: "NH",
    Name: "New Hampshire"
  },
  {
    Id: 38,
    Code: "NJ",
    Name: "New Jersey"
  },
  {
    Id: 39,
    Code: "NM",
    Name: "New Mexico"
  },
  {
    Id: 40,
    Code: "NY",
    Name: "New York"
  },
  {
    Id: 42,
    Code: "NC",
    Name: "North Carolina"
  },
  {
    Id: 43,
    Code: "ND",
    Name: "North Dakota"
  },
  {
    Id: 47,
    Code: "OH",
    Name: "Ohio"
  },
  {
    Id: 48,
    Code: "OK",
    Name: "Oklahoma"
  },
  {
    Id: 50,
    Code: "OR",
    Name: "Oregon"
  },
  {
    Id: 52,
    Code: "PA",
    Name: "Pennsylvania"
  },
  {
    Id: 54,
    Code: "PR",
    Name: "Puerto Rico"
  },
  {
    Id: 56,
    Code: "RI",
    Name: "Rhode Island"
  },
  {
    Id: 59,
    Code: "SC",
    Name: "South Carolina"
  },
  {
    Id: 60,
    Code: "SD",
    Name: "South Dakota"
  },
  {
    Id: 61,
    Code: "TN",
    Name: "Tennessee"
  },
  {
    Id: 62,
    Code: "TX",
    Name: "Texas"
  },
  {
    Id: 63,
    Code: "UT",
    Name: "Utah"
  },
  {
    Id: 64,
    Code: "VT",
    Name: "Vermont"
  },
  {
    Id: 65,
    Code: "VA",
    Name: "Virginia"
  },
  {
    Id: 67,
    Code: "WA",
    Name: "Washington"
  },
  {
    Id: 68,
    Code: "WV",
    Name: "West Virginia"
  },
  {
    Id: 69,
    Code: "WI",
    Name: "Wisconsin"
  },
  {
    Id: 70,
    Code: "WY",
    Name: "Wyoming"
  }
];

class primaryLanguage {
  constructor(languageName, sortOrder) {
    this.languageName = languageName
    this.sortOrder = sortOrder
  }
}

let primaryLanguagesData = primaryLanguage = []
let isPrimaryLanguageHidden = false
let isPrimaryLanguageStateHidden = false
let primaryLanguageState =  ['NJ', 'IL']
let jobState = ''

let brandId = capSvc.getBrand();
capSvc.checkReferral();

window.duplicateWorkHistory = duplicateWorkHistory;
window.duplicateEducationHistory = duplicateEducationHistory;
window.deleteWorkClone = deleteWorkClone;
window.deleteSchoolClone = deleteSchoolClone;
window.validate = validate;
window.returnToSearch = returnToSearch
window.checkEligibilityInput = checkEligibilityInput;
window.showSponsorshipInfo = showSponsorshipInfo;
window.hideSponsorshipInfo = hideSponsorshipInfo;

window.selectRadioBtn = selectRadioBtn
window.continueToStep2EnterKeyboard = continueToStep2EnterKeyboard

let resumeuploaded = false;
let capFileStoreId = 0
let wrkHistory = []
let educationHistory = []
let returningCandidateInfo = []
let submitEmailAddress = null

let candidate = {
  applicationSource: null,
  candidateErecruitId: 0,
  jobErecruitId: 0,
  firstName: null,
  middleName: null,
  lastName: null,
  noMiddleName: true,
  emailAddress: null,
  address1: null,
  address2: null,
  city: null,
  stateProvince: null,
  postalCode: null,
  phone: 0,
  adSourceId: 0,
  eligibilityFlag: true,
  ageFlag: true,
  sponsorshipRequiredFlag: null,
  agreementAcknowledgement: true,
  resumeFileStoreId: 0,
  noWorkHistory: true,
  workHistory: [
    {
      whErecruitId: null,
      companyName: null,
      jobTitle: null,
      jobDescription: null,
      startDate: null,
      endDate: null
    }
  ],
  educationHistory: [
    {
      edErecruitId: null,
      schoolName: null,
      educationLevelId: 0,
      courseOfStudy: null,
      yearsCompleted: 0
    }
  ]
}
let erecruitCandidateId = 0
let erecruitApplicationId = 0
let candidateId = 0
let workCounter = 0
let educationCounter = 0

window.onload = function () {
  const radioInputs = document.querySelectorAll('input[type="radio"]')
  radioInputs.forEach((input) =>{
    input.classList.add('form-check-input')
    input.classList.add('radioValidation')
    if (!input.id.includes('sponsorship'))
      input.setAttribute('required','')
  });
  const selectMsgHtml = `<div class="invalid-feedback" >Please select yes or no</div>`
  const radioLabels = document.querySelectorAll('.radio-style-1-label')
  const emailMsgHtml = `<div class="invalid-feedback mb-2" >Please enter a valid email address</div>`
  const email = document.querySelector('#emailAddress')
  email.setAttribute('pattern', '\\S+@\\S+\\.\\S+')
  if (radioLabels.length > 0)
    $(radioLabels[1]).after(selectMsgHtml);
  if (radioLabels.length > 3)
    $(radioLabels[3]).after(selectMsgHtml);
  $(email).after(emailMsgHtml);

//Remove extra radio divs to display validation message correctly
  let $div
  $div = $('#over18Div');
  $div.replaceWith($div.html());
  $div = $('#under18Div');
  $div.replaceWith($div.html());
  $div = $('#UsAuthorizedDiv');
  $div.replaceWith($div.html());
  $div = $('#noUsAuthorizedDiv');
  $div.replaceWith($div.html());

//part 2 remove Cancel element
  const cancelBtn = document.querySelector('.fileinput-cancel-button')
  cancelBtn.remove()
  const removeBtn = document.querySelector('.fileinput-remove-button')
  removeBtn.remove()
  const uploadBtn = document.querySelector('.fileinput-upload-button')
  uploadBtn.remove()

//part 3 field validation
  const submitRows = document.querySelectorAll('div.row.d-flex.flex-row')
  if (submitRows.length > 1)
    submitRows[1].classList.remove('row');

// Personal info fields
  const firstNameMsgHtml = `<div class="invalid-feedback mb-2" >Please enter your first name</div>`
  const firstName = document.querySelector('#firstName')
  $(firstName).after(firstNameMsgHtml);
  const middleNameMsgHtml = `<div class="invalid-feedback" >Please check box below if no middle name</div>`
  const middleName = document.querySelector('#middleName')
  middleName.setAttribute('required','')
  $(middleName).after(middleNameMsgHtml);
  const lastNameMsgHtml = `<div class="invalid-feedback mb-2">Please enter your last name</div>`
  const lastName = document.querySelector('#lastName')
  $(lastName).after(lastNameMsgHtml);
  const phoneNumberMsgHtml = `<div id='phoneNumberMsg' class="invalid-feedback">Please enter a phone number</div>`
  const phoneNumber = document.querySelector('#phoneNumber')
  phoneNumber.setAttribute('pattern', '^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$')
  $(phoneNumber).after(phoneNumberMsgHtml);
  const address1MsgHtml = `<div class="invalid-feedback">Please enter an address</div>`
  const address1 = document.querySelector('#address1')
  $(address1).after(address1MsgHtml);
  const cityMsgHtml = `<div class="invalid-feedback">Please enter a city</div>`
  const city = document.querySelector('#city')
  $(city).after(cityMsgHtml);
  const statesProvinceMsgHtml = `<div class="invalid-feedback">Please select a state</div>`
  const statesProvince = document.querySelector('#statesProvince')
  // statesProvince.removeAttribute('onchange')
  $(statesProvince).after(statesProvinceMsgHtml);
  const ZipPostalMsgHtml = `<div class="invalid-feedback">Please enter a valid zip code</div>`
  const ZipPostal = document.querySelector('#ZipPostal')
  ZipPostal.setAttribute('minlength', '5')
  ZipPostal.setAttribute('maxlength', '7')
  $(ZipPostal).after(ZipPostalMsgHtml);
  const adSourceMsgHtml = `<div class="invalid-feedback text-left">Please select a source</div>`
  const adSource = document.querySelector('#adSource')
  $(adSource).after(adSourceMsgHtml);
  adSource.removeAttribute("onchange")
  let over18Label = document.querySelector('[for="over18"]')
  $(over18Label).addClass('pt-1')
  let authorizeLabel = document.querySelector('[for="UsAuthorized"]')
  $(authorizeLabel).addClass('pt-1')
  let sponsorshipRequiredLabel = document.querySelector('[for="sponsorshipRequired"]')
  $(sponsorshipRequiredLabel).addClass('pt-1')
  let sponsorshipNotRequiredabel = document.querySelector('[for="sponsorshipNotRequired"]')
  $(sponsorshipNotRequiredabel).addClass('pt-1')

  const otherInputs = document.querySelectorAll('.form-control')
  otherInputs.forEach((input) =>{
    input.classList.add('to-focus')
  });

  let infoRows = document.querySelectorAll('#personalInformation .row')
  $(infoRows[0]).css('margin-bottom','0.5rem')

  let agreeLabel = document.querySelector('[for="hasAgreed"]')
  $(agreeLabel).remove()
  const agreeTextHtml = `<span class="pl-3" > I have read and understand the above Statement of Agreement</span>`
  const agreeInput = document.querySelector('#hasAgreed')
  $(agreeInput).after(agreeTextHtml);

  let statementRow = document.querySelector('#statementOfAgreement .pt-4')
  $(statementRow).addClass('pl-3')

//Boostrap form validation - onload **end

  // removePreloader();
  // const jobId = window.location.search.replace('?jobId=', '')
  getJobDetails(sessionStorage.getItem('jobId'))
  getPrimaryLanguages()
}

function getJobDetails(jobId) {

  $.ajax({
    type: "GET",
    url: sessionStorage.getItem('apiHost') +'Job/Search/' + jobId,
    success: function (data) {
      sessionStorage.setItem('isJobActive', data.isActive)
      if(data.isActive){
        console.log("candidateId: "+sessionStorage.getItem('candidateId') );
        $("body").show();
        document.title = 'Application for ' + sessionStorage.getItem("jobTitle");
        $('#authorizedWarning p').html(sessionStorage.getItem("brandName") + ' is an E-Verify employer, if you are eligible to work in the US, change your response to Yes to continue.');
        const pageTitle = document.getElementById("pageTitle")
        pageTitle.innerHTML = `
      <div id="headerRow" class="d-flex justify-content-center">
          <a id="homePage" href="${sessionStorage.getItem('homePageUrl')}">
            <img id="applicationLogoHeader" alt="${sessionStorage.getItem('brandName')} Logo" class="ml-auto w-100" src="${sessionStorage.getItem('logoImageUrl')}" >
          </a>
        </div>
      <div class="d-flex flex-column justify-content-center flex-wrap font-weight-bolder text-center mb-2">
          <h4 class="my-1">Please submit your application for the position of: </h4>
          <h3 class="my-1">${sessionStorage.getItem("jobTitle")}</h3>
      </div>`
        const nameField = document.querySelector("input");
        nameField.addEventListener("input", () => {
          nameField.setCustomValidity("");
          nameField.checkValidity();
          console.log(nameField.checkValidity());
        });

        nameField.addEventListener("invalid", () => {
          nameField.setCustomValidity("Please fill in your First Name.");
        });

        const statesDropDown = document.getElementById('statesProvince')
        StateProvinces.map(stateProvince => {
          const option = document.createElement('option')
          option.classList.add('dropdown-item')
          option.text = stateProvince.Name
          option.value = stateProvince.Code
          statesDropDown.options.add(option)
        })

        jobState = data.stateProvince
        wrkHistory[workCounter] = $('#previousEmployer-' + workCounter)[0].elements
        educationHistory[educationCounter] = $('#previousEducation-' + educationCounter)[0].elements

        if(sessionStorage.getItem(('candidateId')) !== null){
          $('#emailAddress').val('no email')
          goToStep2()
        } else {
          $('#part1').show();
        }

        capSvc.injectTags("Apply");

        removePreloader();
      }else{
        jobIsInactive()
      }
    },
    beforeSend: function (xhr) {
      xhr.setRequestHeader ('Authorization',
        'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    contentType: 'application/json',
    dataType: 'json'
  });
}

function setPrimaryLanguageVisibility(jobState) {
  const languagesDiv = document.querySelector('#languagesDiv')
  const languageSelector = document.querySelector('#primaryLanguages')

  if(primaryLanguageState.includes(jobState)){
    languagesDiv.removeAttribute('hidden')
    languageSelector.setAttribute('required', true)
    if(jobState === 'IL'){
      languageSelector.labels[0].innerText = 'Primary/Preferred Language'
    }
  }
  else{
    languageSelector.removeAttribute('required')
    languagesDiv.setAttribute('hidden', true)
  }
}

function getPrimaryLanguages(){
  const apiUrl = sessionStorage.getItem('apiHost') + 'Candidate/GetPrimaryLanguages';
  fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Fetched data:', data);

      const primaryLanguagesDDl = document.getElementById('primaryLanguages')
      primaryLanguagesData = data
      primaryLanguagesData.map(language => {
        const option = document.createElement('option')
        option.text = language.languageName
        option.value = language.languageName
        primaryLanguagesDDl.options.add(option)
      })
      setPrimaryLanguageVisibility(jobState)
    })
    .catch(error => console.error('Error fetching data:', error));

}

function jobIsInactive(){

  let markup =
    `<div id="headerRow" class="d-flex flex-column align-self-center">
      <a id="homePage" class="mx-auto" href="${sessionStorage.getItem('homePageUrl')}">
        <img id="applicationLogoHeader" alt="${sessionStorage.getItem('brandName')} Logo" src="${sessionStorage.getItem('logoImageUrl')}" >
      </a>
    <p class="col-14 h4 text-center" style="margin-top: 30%">We're sorry, the Position you have requested is no longer available.</p>
    <button type="button" id="returnToSearch" class="btn btn-application mt-4">Search Active Job Postings</button>

  </div>`
  $('#brandBody').html(markup);
  const returnToSearch = document.querySelector('#returnToSearch')
  returnToSearch.addEventListener('click', () => {
    window.open('../' + brandId, '_self')
  })
  removePreloader();
}
function continueToStep2EnterKeyboard(event){
  if(event.code === 'Enter'){
    const eligible = verifyEligibility()
    if(eligible){
      goToStep2()
    }else{
      displayRequiredFieldsandNoEligible()
    }
  }
}
$('#brandBody')[0].addEventListener('focus', (event) => {
  let over18Focus = true
  for (const element of $('input[type=radio]')) {
    if(element.checked)
      over18Focus = false
  }
  if (over18Focus)
    $('#over18').focus()
})

tabKeyResumeUpload()
tabKeyCheckbox()
tabKeyTextInput()

for (const element of $('select')) {
  element.addEventListener('focus', () =>{
    element.classList.add('border', 'border-primary')
  })

  element.addEventListener('blur', (event) =>{
    if(element.id === 'adSource' && !$('#workHistory').is(':hidden')) $('#noPreviousEmployer').focus()
    element.classList.remove('border', 'border-primary')
  })
  // element.addEventListener('change', (event) => {
  //   if(capFileStoreId !== null) {
  //     $('#hasAgreed').focus()
  //   }
  // })
}

for (const element of $('#continue-step3')) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.1)')
  })
  element.addEventListener('blur', () => {
    element.removeAttribute('style', 'transform: scale(1.1)')
  })
  element.addEventListener('keyup', (event) => {
    if(event.code === 'Enter'){
      element.removeAttribute('style')
      element.click()
    }
  })
}

$("#part1Continue").click(function (e) {
  e.preventDefault(e)
  setTimeout(() => {
    $("#part1Continue").prop('disabled',true);
    $("#part1Continue").css('transform','scale(1.3)')
  }, "200")

  // Boostrap form validation - part1Continue **begin
  'use strict'
  // $('#submitApplication').prop('disabled',false)
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  let forms = document.querySelectorAll('.needs-validation')
  // forms[0][18].pattern = "^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$"
  // forms[0][17].pattern = "^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$"
  forms[0][19].pattern = "^\\(?\\d{3}\\)?[- ]?\\d{3}[-]?\\d{4}$"

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        let firstInvalidRadio = $(form).find(".form-check-input:invalid").first();
        let firstInvalid;
        if (firstInvalidRadio != null) {
          firstInvalid = firstInvalidRadio;
        }
        window.scrollTo({
          top: 200,
          behavior: 'instant'
        });
        if (!verifyEligibility())
          firstInvalid.focus();
      }
      form.classList.add('was-validated')
    })
  // Boostrap form validation - part1Continue end

  const eligible = verifyEligibility()
  if(eligible){
    goToStep2()
    return  true
  }else{
    displayRequiredFieldsandNoEligible()
    return false
  }
})

$('#upload-Resume').click(function () {
  if($('#uploadFile').val() === ''){
    return false
  }else{
    //Boostrap form validation - bypass checking work history and education parts
    const whInputs = document.querySelectorAll('#workHistoryBody input, #workHistoryBody  textarea, #workHistoryBody select');
    //  alert("whInputs id = " + whInputs[1].id)
    $('#companyName-0').removeAttr('required');
    whInputs.forEach((input) =>{
      //   console.log("input id = " + input.id)
      if (input.id !== 'whErecruitId')
        input.removeAttribute('required')
    });
    const edInputs = document.querySelectorAll('#educationHistoryBody input, #educationHistoryBody textarea, #educationHistoryBody select');
    edInputs.forEach((input) =>{
      //    console.log("input id = " + input.id)
      if (input.id !== 'edErecruitId')
        input.removeAttribute('required')
    });

    const fd = new FormData();
    const files = $('#uploadBtn')[0].files[0];
    fd.append('CandidateResume', files);
    resumeuploaded = true;
    $.ajax({
      url: sessionStorage.getItem('apiHost') + 'Candidate/PostResume',
      type: 'post',
      data: fd,
      contentType: false,
      processData: false,
      success: function (response){
        capFileStoreId = response.capFileStoreId
        $('#part2').hide()
        $('#part3').show()
        const statesDropDown = document.getElementById('statesProvince')
        statesDropDown.value = ''
        $('#statesProvince').change(function (event) {
          setPrimaryLanguageVisibility(event.currentTarget.value)
        })

        $('#primaryLanguages').change(function (event){
          const otherLanguageDiv = document.querySelector('#otherLanguageDiv')
          const otherLanguage = document.querySelector('#languageInput')
          if(event.currentTarget.value === 'Other'){
            otherLanguageDiv.removeAttribute('hidden')
            otherLanguage.setAttribute('required', true)
          }
          else{
            otherLanguage.removeAttribute('required')
            otherLanguageDiv.setAttribute('hidden', 'hidden')
          }
        })

        if(sessionStorage.getItem('referralAdSourceId') !== null){
          $('#adSource').val(sessionStorage.getItem('referralAdSourceId'));
          $('#adSourceBox').attr('style','display:none !important');
        }
        if(erecruitCandidateId === null){
          $('#workHistory').hide()
          $('#educationHistory').hide()

          return true
        }else{
          populateReturningCandidate()
        }
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader ('Authorization', 'Bearer 2IPs42mwzjHdK3p7NQdyayOUWMQQkgAozYRiAJkjJNqW768JDzlxF5dJE49ePupId7NsVz9TtItb6gWepgcgPDOc7vpI1IEMoGbwHcYgZ5835tjNdOiHG3L37hCMVQ63');
        xhr.setRequestHeader ('JwtAuthorization', sessionStorage.getItem('jwt'));
        xhr.setRequestHeader ('Origin', 'https://employeeworkplace.com');
        xhr.setRequestHeader ('UserControl', sessionStorage.getItem('jwt'));
      },
      error: function (textStatus, errorThrown){
        console.log(errorThrown)
      }
    })
  }
})

$('#uploadBtn').change(function () {
  $('#uploadFile').val(this.value.replace(/^.*\\/, ""))
  $('#upload-Resume').prop('disabled',false)
})

$('#continue-step3').click(function (){
  capFileStoreId = null
  if(erecruitCandidateId !== null){
    populateReturningCandidate()
  }
  if(sessionStorage.getItem('referralAdSourceId') !== null){
    $('#adSource').val(sessionStorage.getItem('referralAdSourceId'));
    $('#adSourceBox').attr('style','display:none !important');
  }

  $('#part2').hide()
  $('#part3').show()

  // Boostrap form validation - Work history fields
  const companyNameMsgHtml = `<div class="invalid-feedback">Please enter company name</div>`
  const companyName = document.querySelector('#companyName')
  $(companyName).after(companyNameMsgHtml);
  const jobTitleMsgHtml = `<div class="invalid-feedback">Please enter job title</div>`
  const jobTitle = document.querySelector('#jobTitle')
  $(jobTitle).after(jobTitleMsgHtml);
  const jobFromMsgHtml = `<div id="jobFromMsg" class="invalid-feedback">Please enter from date</div>`
  const jobFrom = document.querySelector('#jobFrom')
  jobFrom.setAttribute('pattern', '^(0[1-9]|1[0-2])\\/[/]?([1-2][0-9]{3})$')
//  jobFrom.setAttribute('pattern', '(0[1-9]|1[0-2])([/])([1-2][0-9][0-9][0-9])')
  jobFrom.setAttribute('name','jobFrom')
  $(jobFrom).after(jobFromMsgHtml);
 // jobFrom.id = 'jobFrom-0'

  const jobToMsgHtml = `<div id="jobToMsg" class="invalid-feedback">Please enter to date</div>`
  const jobTo = document.querySelector('#jobTo')
  jobTo.setAttribute('pattern', '^(0[1-9]|1[0-2])\\/[/]?([1-2][0-9]{3})$')
  jobTo.setAttribute('name', 'jobTo')
    $(jobTo).after(jobToMsgHtml);
 // jobTo.id = 'jobTo-0'
  const jobDescriptionMsgHtml = `<div class="invalid-feedback">Please enter job description</div>`
  const jobDescription = document.querySelector('#jobDescription')
  $(jobDescription).after(jobDescriptionMsgHtml);

  // Boostrap form validation - Education history fields
  const educationLevelMsgHtml = `<div class="invalid-feedback">Please select a degree type</div>`
  const educationLevel = document.querySelector('#educationLevel')
  $(educationLevel).after(educationLevelMsgHtml);
  const schoolNameMsgHtml = `<div class="invalid-feedback">Please enter a school name</div>`
  const schoolName = document.querySelector('#schoolName')
  $(schoolName).after(schoolNameMsgHtml);
  const courseOfStudyMsgHtml = `<div class="invalid-feedback">Please enter a course of study</div>`
  const courseOfStudy = document.querySelector('#courseOfStudy')
  $(courseOfStudy).after(courseOfStudyMsgHtml);
  const yearsCompletedMsgHtml = `<div class="invalid-feedback">Please enter years completed</div>`
  const yearsCompleted = document.querySelector('#yearsCompleted')
  $(yearsCompleted).after(yearsCompletedMsgHtml);
// Boostrap form validation - Education history fields end

  let isReturningCandidate = false
  if (returningCandidateInfo !== null && (returningCandidateInfo !== undefined && returningCandidateInfo.length > 0)){
    isReturningCandidate = true
  }

  const languages = document.querySelector('#languagesDiv')
  const languageSelector = document.querySelector('#primaryLanguages')

  if(primaryLanguageState.includes(jobState) &&  !isReturningCandidate){
    languages.removeAttribute('hidden')
    languageSelector.setAttribute('required', true)
    if(jobState === 'IL'){
      languageSelector.labels[0].innerText = 'Primary/Preferred Language'
    }
  }else{
    languages.setAttribute('hidden', true)
    languageSelector.removeAttribute('required')
  }

  $('#statesProvince').change(function (event) {
    if(primaryLanguageState.includes(event.currentTarget.value) ||
       primaryLanguageState.includes(jobState)){
      languages.removeAttribute('hidden')
      languageSelector.setAttribute('required', true)
    }
    else{
      languages.setAttribute('hidden', true)
      languageSelector.removeAttribute('required')
    }
  })

  $('#primaryLanguages').change(function (event){
    const otherLanguageDiv = document.querySelector('#otherLanguageDiv')
    const otherLanguage = document.querySelector('#languageInput')
    if(event.currentTarget.value === 'Other'){
      otherLanguageDiv.removeAttribute('hidden')
      otherLanguage.setAttribute('required', true)
    }
    else{
      otherLanguage.removeAttribute('required')
      otherLanguageDiv.setAttribute('hidden', 'hidden')
    }
  })
  if(erecruitCandidateId === null){
    const statesDropDown = document.getElementById('statesProvince')
    statesDropDown.value = ''
  }
})

$('#eligibilityForm').on('submit',function(event){
  event.preventDefault()
  const eligible = verifyEligibility()
  if(eligible){
    goToStep2()
  }else{
    displayRequiredFieldsandNoEligible()
  }
})
function verifyEligibility(){
  if ($("#over18").is(":checked") && $('#UsAuthorized').is(":checked") && $('#emailAddress').val() !== "")
  {
    const re = /\S+@\S+\.\S+/
    let match = false
    match = re.test($('#emailAddress').val())
    if(!match){
      return false
    }
    return true
  }
  else {
    return false
  }
}
function displayRequiredFieldsandNoEligible(){
  if ($('#emailAddress').val() === '') {
  } else {
    if ($('#under18').is(":checked") || $('#noUsAuthorized').is(":checked")) {
      $('#part1').hide()
      $('#noEligible').show()
    }
  }

}

function populateReturningCandidate(){
  $('#returningCandidateFieldSet')[0].setAttribute('hidden', 'hidden')
  $('#returningCandidateDiv')[0].setAttribute('hidden', 'hidden')
  $('#languagesDiv')[0].setAttribute('hidden', 'hidden')
  $('#workHistory')[0].setAttribute('hidden', 'hidden')
  $('#educationHistory').attr('hidden', true)
  $('#welcomeBackMsg')[0].outerText = 'Welcome Back ' + returningCandidateInfo[0]['firstName'] + '!'
  $('#retuningCandidateMsgDiv')[0].classList.add('fw-bold')
  $('#retuningCandidateMsgDiv')[0].fontsize = '18px'
  $('#statesProvince')[0].value = null
  // const forms = document.querySelectorAll('.needs-validation')
  // Array.prototype.slice.call(forms)
  //   .forEach(function (form) {
  //     form.reset()
  //      // for (let i = 0; i < form.length; i++){
  //      //   if(form[i].id !== 'adSource'){
  //      //     form[i].setCustomValidity('')
  //      //   }
  //      // }
  //   })


  // notValidateHistory();
  //
  // $('#firstName').val(returningCandidateInfo[0]['firstName'])
  // $('#firstName').prop('disabled', true)
  //
  // if($('#middleName').val() !== null && $('#middleName').val() !== ""){
  //   $('#middleName').val(returningCandidateInfo[0]['middleName'])
  //   $('#noMiddleName').prop('checked',false)
  //   $('#noMiddleName').prop('disabled',true)
  //   $('#middleName').prop('disabled', true)
  // }else{
  //   $('#noMiddleName').prop('checked',true)
  //   $('#noMiddleName').prop('disabled',true)
  //   $('#middleName').prop('disabled', true)
  // }
  // // $('#noMiddleName').prop('disabled', true)
  //
  // $('#lastName').val( returningCandidateInfo[0]['lastName'])
  // $('#lastName').prop('disabled', true)
  // $('#phoneNumber').val(returningCandidateInfo[0]['phoneNumber'])
  // // $('#phoneNumber').setAttribute('disabled', 'disabled')
  // formatPhone(returningCandidateInfo[0]['phoneNumber'])
  // //
  // $('#linkedInUrl').val(returningCandidateInfo[0]['linkedInUrl'])
  // $('#address1').val(returningCandidateInfo[0]['address1'])
  // // $('#address1').setAttribute('disabled', 'disabled')
  // //
  // $('#address2').val(returningCandidateInfo[0]['address2'])
  // // $('#address2').setAttribute('disabled', 'disabled')
  // //
  // $('#statesProvince').val(returningCandidateInfo[0]['stateProvince'])
  // // $('#statesProvince').setAttribute('disabled', 'disabled')
  // //
  // $('#city').val(returningCandidateInfo[0]['city'])
  // // $('#city').setAttribute('disabled', 'disabled')
  // //
  // $('#ZipPostal').val(returningCandidateInfo[0]['postalCode'])
  // // $('#ZipPostal').setAttribute('disabled', 'disabled')
  // setPrimaryLanguageVisibility(returningCandidateInfo[0]['stateProvince'])
  //
  // if(returningCandidateInfo[1].length > 0 && returningCandidateInfo[1][0]["whErecruitId"] !== null){
  //   var previousEmployeeElement = $('#previousEmployer-0')
  //   previousEmployeeElement[0].elements['whErecruitId'].value = returningCandidateInfo[1][0]["whErecruitId"]
  //   previousEmployeeElement[0].elements['companyName'].value = returningCandidateInfo[1][0]["companyName"]
  //   previousEmployeeElement[0].elements['jobTitle'].value = returningCandidateInfo[1][0]["jobTitle"]
  //   previousEmployeeElement[0].elements['jobDescription'].value = returningCandidateInfo[1][0]["jobDescription"]
  //   previousEmployeeElement[0].elements['jobFrom'].value = returningCandidateInfo[1][0]["startDate"]
  //   previousEmployeeElement[0].elements['jobTo'].value = returningCandidateInfo[1][0]["endDate"]
  //   $("#previousEmployer-0 .form-control").prop("disabled",true)
  //   console.log(' whErecruitId: ' + previousEmployeeElement[0].elements["whErecruitId"].value)
  //   if(returningCandidateInfo[1].length > 1){
  //     $("#noPreviousEmployer").prop("disabled",true)
  //     for(var i = 1; i < returningCandidateInfo[1].length; i++){
  //       duplicateWorkHistory(false,returningCandidateInfo[1][i])
  //     }
  //   }
  // }
  //
  // if(returningCandidateInfo[2].length > 0 && returningCandidateInfo[2][0]["edErecruitId"] !== null){
  //   const previuosEducation = $('#previousEducation-0')
  //   previuosEducation[0].elements['edErecruitId'].value = returningCandidateInfo[2][0]["edErecruitId"]
  //   previuosEducation[0].elements['educationLevel'].value = returningCandidateInfo[2][0]["educationLevelId"]
  //   previuosEducation[0].elements['schoolName'].value = returningCandidateInfo[2][0]["schoolName"]
  //   previuosEducation[0].elements['courseOfStudy'].value = returningCandidateInfo[2][0]["courseOfStudy"]
  //   previuosEducation[0].elements['yearsCompleted'].value = returningCandidateInfo[2][0]["yearsCompleted"]
  //   $("#previousEducation-0 .form-control").prop("disabled",true)
  //   console.log(' edErecruitId: ' + previuosEducation[0].elements["edErecruitId"].value)
  //   if(returningCandidateInfo[2].length > 1){
  //     $("#noPreviousEmployer").prop("disabled",true)
  //     for(var c = 1; c < returningCandidateInfo[2].length; c++){
  //       duplicateEducationHistory(false,returningCandidateInfo[2][c])
  //     }
  //   }
  // }
}
function notValidateHistory(){
  const whInputs = document.querySelectorAll('#workHistoryBody input, #workHistoryBody  textarea, #workHistoryBody select');
  whInputs.forEach((input) =>{
    //   console.log("input id = " + input.id)
      input.removeAttribute('required')
  });
  const edInputs = document.querySelectorAll('#educationHistoryBody input, #educationHistoryBody textarea, #educationHistoryBody select');
  edInputs.forEach((input) =>{
    //    console.log("input id = " + input.id)
      input.removeAttribute('required')
  });

}
function goToStep2(){
  let checkCandidateId = sessionStorage.getItem('candidateId');
  submitEmailAddress = $('#emailAddress').val()
  if (checkCandidateId === null){
    checkCandidateId = 0;
  }
  // Boostrap form validation - reset form validation and set agreement attribute and classes  **begin
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  const agreedMsgHtml = `<div class="invalid-feedback" >Please check agreement box</div>`
  const hasAgreedInput = document.querySelector('#hasAgreed')
  hasAgreedInput.setAttribute('required','')
  hasAgreedInput.classList.add('form-check-input')
  hasAgreedInput.classList.add('to-focus')
  const hasAgreedLabel = document.querySelector('.pl-3')
  $(hasAgreedLabel).after(agreedMsgHtml);
  // Boostrap form validation - reset form validation....  **end

  $.ajax({
    url: sessionStorage.getItem('apiHost') + "checkCandidate",
    dataType: 'json',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      emailAddress: $('#emailAddress').val(),
      jobId: parseInt(sessionStorage.getItem('jobId')),
      candidateId: checkCandidateId
    }),
    processData: false,
    success: function (data, textStatus){
      const t = data
      console.log(data)
      erecruitCandidateId =  data.erecruitCandidateId
      erecruitApplicationId = data.erecruitApplicationId
      candidateId = data.erecruitCandidateId
      sessionStorage.setItem('jwt',data.jwt);
      console.log('jwt ' + sessionStorage.getItem('jwt'))
      const adSource = document.getElementById('adSource')
      data.adSource.map(adSources => {
        const option = document.createElement('option')
        option.text = adSources.adSourceName
        option.value = adSources.erecruitAdSourceId
        adSource.options.add(option)
      })

      const degreeType = document.getElementById('educationLevel')
      data.educationLevels.map(dt => {
        const option = document.createElement('option')
        option.text = dt.description
        option.value = dt.erecruitEducationLevelId
        degreeType.options.add(option)
      })

      if(erecruitCandidateId === null){
        console.log("new candidate")
        $('#newApplicantResume').show();
        $('#part1').hide()
        $('#part2').show()
      }
      else {
       // $('#emailAddress').val(data.personalInfo[0].emailAddress);
        $('#middleName').val(data.personalInfo[0].middleName)
        submitEmailAddress = $('#emailAddress').val();
        if(erecruitApplicationId === null){
          $('#returningApplicantResume').show()
          $('#part1').hide()
          $('#part2').show()
          returningCandidateInfo.push(data.personalInfo[0])
          returningCandidateInfo.push(data.workHistory)
          returningCandidateInfo.push(data.educationHistory)
        }
        else {
          $('#part1').hide()
          $('#part2').hide()
          $('#previousApplied').show()
          return false
        }
      }
      return true
    },
    beforeSend: function (xhr) {
      xhr.setRequestHeader ('Authorization', 'Bearer XwgtlQw0sZ2NJsJHJS8pOM7quIiE1vhzXTu1XbQ1fvwXdEnnpSUsOOdBqS8AKJxLya6QUs8RIwN7FPsvArhGVrfTPTCWT8WWZthkxgUvSTsY3zHoBDIAWMdn2IMZl8l9');
    },
    error: function (textStatus, errorThrown){
      console.log(errorThrown)
    }
  })
}

$('#phoneNumber').change(function(event) {
  //   alert("phoneNumber entered")
  let pattern = $('#phoneNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test($('#phoneNumber').val())) {
    $('#validatePhoneNumber').css('display', 'none');
    //  $('#phoneNumber').css('background', 'white');
  }else
  if ($('#phoneNumber').val() !== '')
    $('#validatePhoneNumber').css('display','block')
});

function formatPhone(phone){
  if(event.keyCode !== 8){
    if((event.key === undefined || !isNaN(event.key)) || phone === '' ){
      if(phone.length === 10){
          $('#validatePhoneNumber').css('display', 'none')
          const curchr = phone.length;
          let curval = phone;
          curval = curval.replace(/\D/g,'').substring(0,10)
          if (curchr === 10 && !curval.includes('('))
          {
            const areaCode = curval.substring(0, 3)
            const phonePart1 = curval.substring(3, 6)
            const phonePart2 = curval.substring(6, 10)
            $('#phoneNumber').val("(" + areaCode + ")" + " " + phonePart1 + '-' + phonePart2)
            $('#phoneNumber').css('background-color','white')
          }
      }
    }else{
      $('#validatePhoneNumber').css('display', 'block');
    }
  }
  else if(event.keyCode === 8){
    if(phone.length > 0){
      if(!isNaN(phone[phone.length - 1])){
        $('#validatePhoneNumber').css('display', 'none')
      }
    }
    else{
      $('#validatePhoneNumber').css('display', 'none')
    }
  }
}

$('#emailAddress').change(function () {
  const re = /\S+@\S+\.\S+/
  let match = false
  match = re.test($('#emailAddress').val())
  if (!match) {
    $('#emailAddress').val() !== '' ?
      $('#eligibilityMsg').text('Invalid Email') : $('#eligibilityMsg').text('Please enter email address')
    $('#eligibilityMsg').show()
    $('#emailAddress').css('background-color','pink')
    $("#part1Continue").prop('disabled',true);
  } else {
    $('#eligibilityMsg').text('')
    $('#eligibilityMsg').hide()
    $('#emailAddress').css('background-color','white')
    $("#part1Continue").prop('disabled',false);
  }
})

$('#emailAddress').on('keyup', event => {
  if(event.keyCode === 13){
    $("#part1Continue").click()
  }
})

for (const button of $('#part1Continue')) {
  button.addEventListener('focus', (event) => {
    button.setAttribute('style', 'transform: scale(1.3)')
  })
  button.addEventListener('blur', (event) => {
    button.removeAttribute('style')
  })
  button.addEventListener('keyup', (event) => {
    if(event.code === 'Enter'){
      continueToStep2EnterKeyboard(event)
    }
  })
}

$('#hasAgreed').click(function (){
  if(!$('#hasAgreed').is(":checked")){
    $('#submitApplication').prop('disabled', true)
  }else{
    $('#submitApplication').prop('disabled',false)
  }
})

$('#phoneNumber').keyup(function(event) {
  formatPhone(event.currentTarget.value)
  //Boostrap form validation...
  if (event.currentTarget.value !== '')
    $('#phoneNumberMsg').css("display","none")
  else
    $('#phoneNumberMsg').css("display","block")
  let pattern = $('#phoneNumber').attr("pattern")
  let regex = new RegExp(pattern);
  if (regex.test($('#phoneNumber').val()))
    $('#validatePhoneNumber').css('display', 'none');
});

$('#noMiddleName').click(function () {
  if($('#noMiddleName').is(":checked")){
    $('#middleName').val('')
    $('#middleName').css('background-color','none')
    $('#middleName').prop('disabled',true)
  }else{
    $('#middleName').prop('disabled',false)
  }
})

$('#noPreviousEmployer').click(function (){
  if($('#noPreviousEmployer').is(":checked")){
    $('#companyName').prop('disabled', true)
    $('#jobTitle').prop('disabled', true)
    $('#jobDescription').prop('disabled', true)
    $('#jobFrom').prop('disabled', true)
    $('#jobTo').prop('disabled', true)
    $('#addEmployer').hide();
  }else{
    $('#companyName').prop('disabled', false)
    $('#jobTitle').prop('disabled', false)
    $('#jobDescription').prop('disabled', false)
    $('#jobFrom').prop('disabled', false)
    $('#jobTo').prop('disabled', false)
    $('#addEmployer').show();
  }

})

const submitApplication = $('#submitApplication')

submitApplication.click(function (e){
  e.preventDefault(e)
  // Boostrap form validation - #submitApplication  **begin
  let valid = false
  let tempPhone
  if(returningCandidateInfo.length === 0){
    if($('#phoneNumber').val() === '') {
      // Boostrap form validation
      let cellNumber
      $('#validatePhoneNumber').css('display', 'none');
    }
    const jobFroms = document.querySelectorAll("input[name='jobFrom']")
    jobFroms.forEach((from ) =>{
      if ( $(from).val() === "") {
        $(from).removeAttr('style')
        let msgId = from.nextElementSibling.id
        //  console.log('msgId = ' + msgId)
        $('#'+ msgId).removeAttr('style')
        $('#'+ msgId).text('Please enter from date')
      }
    })
    const jobTos = document.querySelectorAll("input[name='jobTo']")
    jobTos.forEach((to ) =>{
      if ( $(to).val() === "") {
        $(to).removeAttr('style')
        let msgId = to.nextElementSibling.id
        //  console.log('msgId = ' + msgId)
        $('#'+ msgId).removeAttr('style')
        $('#'+ msgId).text('Please enter to date')
      }
    })

    let firstInvalidJobDate
    let targetDate = 0
    if (document.querySelectorAll('.invalidJobDate').length > 0) {
      firstInvalidJobDate = $('#applicationForm').find(".invalidJobDate").first();
      targetDate = firstInvalidJobDate.offset().top - 130;
      //  console.log("target date = " + targetDate);
    }

//  console.log('valid1: ' + valid)
    let firstCheckDone = false
    'use strict'
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    let forms = document.querySelectorAll('.needs-validation')
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
          let firstInvalid = $(form).find(".to-focus:invalid").first();
          let target = firstInvalid.offset().top - 130;
          //    console.log("target = " + target);
          if (targetDate !== 0 && targetDate < target){
            target = targetDate
            firstInvalid = firstInvalidJobDate
            $(firstInvalid).css('box-shadow', '0 0 0 0.25rem rgb(220 53 69 / 25%)')
          }
          window.scrollTo({
            top: target,
            behavior: 'instant'
          });
          firstInvalid.focus();
        }else {
          valid = true;
        }
        form.classList.add('was-validated')
      })
    if (valid)
      firstCheckDone = true;

    if($('#phoneNumber').val() === ''){
      valid = false
    } else {
      tempPhone = document.getElementById('phoneNumber').value.trim().replace("(", "").replace(")", "").replace("-", "").split('')
      tempPhone = tempPhone.filter(function (ele){
        return ele !== ' ';
      })
      tempPhone = tempPhone.join(",").replaceAll(",","")

    }
    if(!resumeuploaded || erecruitCandidateId !== null){

      if (!$('#noPreviousEmployer').is(":checked")){
        const invalidJobDates = document.querySelectorAll('.invalidJobDate')
        invalidJobDates.forEach((jobDate) =>{
          $(jobDate).css('border-color','#dc3545')
          //    $(jobDate).css('box-shadow', '0 0 0 0.25rem rgb(220 53 69 / 25%)')
          $(jobDate).css('background-image',"url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
          valid = false
        });
      }
      if (!valid && firstCheckDone){
        firstInvalidJobDate = $('#applicationForm').find(".invalidJobDate").first();
        targetDate = firstInvalidJobDate.offset().top - 130;
        window.scrollTo({
          top: targetDate,
          behavior: 'instant'
        });
        $(firstInvalidJobDate).css('box-shadow', '0 0 0 0.25rem rgb(220 53 69 / 25%)')
        firstInvalidJobDate.focus();
      }
    }
  }else{
    if($('#adSource').val() !== ''){
      valid = true
      $('#adSource').css('background-color','white')
    }else{
      $('#adSource')[0].classList.add('invalid')
      $('#adSource').css('background-color','pink')
      $('#adSource').focus()
    }
  }
  console.log('valid2: ' + valid)
  if(valid){
    $('#submitApplication').prop('disabled', true)
    $("#submitApplication").css('transform','scale(1.3)')
    var tempWH = []
    var whDetails = null
    if((erecruitCandidateId === null && !resumeuploaded) || erecruitCandidateId !== null){
      if (!$('#noPreviousEmployer').is(":checked") && !$('#workHistory').is(':hidden')){
        $('.workHistoryItem').each(function(){
          var $whItem = $(this)
          if($whItem.children('#whErecruitId').val().length === 0){
            whDetails = {
              whErecruitid:null,
              companyName: $whItem.find('#companyName').val().trim(),
              jobTitle: $whItem.find('#jobTitle').val().trim(),
              jobDescription: $whItem.find('#jobDescription').val().trim(),
              // startDate: $whItem.find('#jobFrom').val().trim(),
              // endDate: $whItem.find('#jobTo').val().trim()
              startDate: $whItem.find('[name="jobFrom"]').val().trim(),
              endDate: $whItem.find('[name="jobTo"]').val().trim()
            }
            console.log(whDetails)
            tempWH.push(whDetails)
            console.log(tempWH)
          }
        })
      }
    }
    var tempEH = []
    var ehDetails = null
    console.log(educationHistory)
    if((erecruitCandidateId === null && !resumeuploaded) || erecruitCandidateId !== null){
      $('.edHistoryItem').each(function(i){
        var $edItem = $(this)
        if($edItem.children('#edErecruitId').val().length === 0 && !$('#educationHistory').is(':hidden')){
          ehDetails = {
            edErecruitid: null,
            educationLevelId: Number($edItem.find('#educationLevel').val().trim()),
            schoolName: $edItem.find('#schoolName').val().trim(),
            courseOfStudy: $edItem.find('#courseOfStudy').val().trim(),
            yearsCompleted: Number($edItem.find('#yearsCompleted').val().trim())
          }
          tempEH.push(ehDetails)
          console.log(tempWH)
        }
      })
    }
    let sponsorshipRequired = null;
    if ( $('#sponsorshipRequired').is(":checked")){
      sponsorshipRequired = true;
    } else if ( $('#sponsorshipNotRequired').is(":checked")){
      sponsorshipRequired = false;
    }

    let primaryLanguage = null
    let primaryLanguageInput = null
    if(!$('#languagesDiv').is(':hidden')){
      primaryLanguage = $('#primaryLanguages').val().toString()
      primaryLanguageInput = $('#languageInput').val() === '' ? null : $('#languageInput').val()
    }

    candidate = {
      applicationSource: "CAP",
      jobErecruitId: Number(sessionStorage.getItem('jobId')),
      candidateErecruitId: candidateId,
      firstName: document.getElementById('firstName').value === '' ? null : document.getElementById('firstName').value.trim() ,
      middleName: document.getElementById('middleName').value === '' ? null : document.getElementById('middleName').value.trim() ,
      noMiddleName: document.getElementById('noMiddleName').value === 'on',
      lastName: document.getElementById('lastName').value === '' ? null : document.getElementById('lastName').value.trim() ,
      phone:  tempPhone, // document.getElementById('phoneNumber').value === '' ? null : Number(document.getElementById('phoneNumber').value)  ,
      emailAddress: submitEmailAddress,
      address1: document.getElementById('address1').value === '' ? null : document.getElementById('address1').value.trim() ,
      address2: document.getElementById('address2').value === '' ? null : document.getElementById('address2').value.trim() ,
      city: document.getElementById('city').value === '' ? null : document.getElementById('city').value.trim() ,
      stateProvince: returningCandidateInfo.length !== 0 ? null : document.getElementById('statesProvince').value === '' ? null : document.getElementById('statesProvince').value.trim(),
      postalCode: document.getElementById('ZipPostal').value === '' ? null : document.getElementById('ZipPostal').value.trim() ,
      adSourceId: document.getElementById('adSource').value === '' ? null : Number(document.getElementById('adSource').value.trim()) ,
      eligibilityFlag: true,
      ageFlag: true,
      sponsorshipRequiredFlag: sponsorshipRequired,
      agreementAcknowledgement: true,
      resumeFileStoreId: capFileStoreId,
      workHistory: tempWH,
      educationHistory: tempEH,
      noWorkHistory: $('#noPreviousEmployer').is(":checked"),
      LanguageSelected: primaryLanguage,
      LanguageEntered: primaryLanguageInput
    }
    console.log('candidate: ' +JSON.stringify(candidate))
    $.ajax({
      url: sessionStorage.getItem('apiHost') + "Candidate/Submit",
      dataType: 'json',
      type: 'post',
      contentType: 'application/json',
      data: JSON.stringify(candidate),
      processData: false,
      success: function (data){
        const t = data
        let sourceParam = ''
        if (capSvc.getUrlParameter("source") !== false) {
          sourceParam = '&source=' + capSvc.getUrlParameter("source")
        }
        if (window.location.origin.includes('localhost')) {
          window.location.href = window.location.origin + '/' + sessionStorage.getItem('brandId') + '/thank-you.html?jobId=' + sessionStorage.getItem('jobId') + sourceParam;
        } else{
          window.location.href = window.location.origin + '/jobs/' + sessionStorage.getItem('brandId') + '/thank-you?jobId=' + sessionStorage.getItem('jobId') + sourceParam;
        }
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader ('Authorization', 'Bearer 2IPs42mwzjHdK3p7NQdyayOUWMQQkgAozYRiAJkjJNqW768JDzlxF5dJE49ePupId7NsVz9TtItb6gWepgcgPDOc7vpI1IEMoGbwHcYgZ5835tjNdOiHG3L37hCMVQ63');
        xhr.setRequestHeader ('JwtAuthorization', sessionStorage.getItem('jwt'));
        xhr.setRequestHeader ('Origin', 'https://employeeworkplace.com');
        xhr.setRequestHeader ('UserControl', sessionStorage.getItem('jwt'));
      },
      error: function (textStatus, errorThrown){
        console.log(errorThrown)
      }
    })
  }
})

for (const element of submitApplication) {
  element.addEventListener('focus', () => {
    element.setAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('blur', () => {
    element.removeAttribute('style', 'transform: scale(1.3)')
  })
  element.addEventListener('keyup', (event) => {
    if(event.code === 'Enter'){
      $('#submitApplication').click()
    }
  })
}

function returnToSearch(){
  window.location.href = window.location.origin + '/jobs/' + sessionStorage.getItem('brandId')
}

function duplicateWorkHistory(isNew,workHistory){
  //Boostrap from validation - duplicateWorkHistory reset form validation **begin
//  $('#submitApplication').prop('disabled',false)
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  //Boostrap from validation - reset form validation **end

  var original = document.getElementById('previousEmployer-0');
  var clone = original.cloneNode(true); // "deep" clone
  clone.id = "previousEmployer-" + ++workCounter; // there can only be one element with an ID
  clone.children[1].children[1].children[0].id = "removePreviousEmployer-" + workCounter;
  if(isNew){
    clone.elements["whErecruitId"].value = null
    clone.elements["companyName"].value = ''
    clone.elements['jobTitle'].value = ''
    clone.elements['jobDescription'].value = ''
  //clone.elements['jobFrom'].value = ''
    clone.elements["jobFrom"].id = "jobFrom-" + workCounter
    clone.elements["jobFrom-" + workCounter].value = ''
    clone.elements["jobFrom-" + workCounter].addEventListener('change', event => {
      validateFromDate(event)
    })
    clone.elements["jobFrom-" + workCounter].nextElementSibling.id = 'jobFromMsg-' + workCounter
    // clone.elements['jobTo'].value = ''
    clone.elements["jobTo"].id = "jobTo-" + workCounter
    clone.elements["jobTo-" + workCounter].value = ''
    clone.elements["jobTo-" + workCounter].addEventListener('change', event => {
      validateToDate(event)
    })
    clone.elements["jobTo-" + workCounter].nextElementSibling.id = 'jobToMsg-' + workCounter
    for(var i = 0; i < clone.elements.length; i++){
      clone.elements[i].disabled = false
    }
    clone.children[1].children[1].style.display = "block"
  } else {
    clone.elements["whErecruitId"].value = workHistory['whErecruitId'] !== undefined && workHistory['whErecruitId'] !== '' ? workHistory['whErecruitId'] : ''
    clone.elements["companyName"].value = workHistory['companyName'] !== undefined && workHistory['companyName'] !== '' ? workHistory['companyName'] : ''
    clone.elements['jobTitle'].value = workHistory['jobTitle'] !== undefined && workHistory['jobTitle'] !== '' ? workHistory['jobTitle'] : ''
    clone.elements['jobDescription'].value = workHistory['jobDescription'] !== undefined && workHistory['jobDescription'] !== '' ? workHistory['jobDescription'] : ''
    clone.elements['jobFrom'].value = workHistory['startDate'] !== undefined && workHistory['startDate'] !== '' ? workHistory['startDate'] : ''
    clone.elements['jobTo'].value = workHistory['endDate'] !== undefined && workHistory['endDate'] !== '' ? workHistory['endDate'] : ''
    for(let i = 0; i < clone.elements.length; i++){
      clone.elements[i].disabled = true
    }
    clone.children[1].children[1].style.display = "none"
  }
  console.log(' whErecruitId: ' + clone.elements["whErecruitId"].value)
  wrkHistory.push(clone.elements)
  document.getElementById('workHistoryBody').append(clone);
  $('#jobFromMsg-' + workCounter ).css('display', 'none');
  $('#jobToMsg-' + workCounter ).css('display', 'none');
  $("#jobFrom-" + workCounter).removeClass("invalidJobDate")
  $("#jobTo-" + workCounter).removeClass("invalidJobDate")

  const jobFroms = document.querySelectorAll("input[name='jobFrom']")
  jobFroms.forEach((from ) =>{
    $(from).removeAttr('style')
    $(from).css('border-color', '#696969')
    $(from).css('background-image', '')
  })
  const jobTos = document.querySelectorAll("input[name='jobTo']")
  jobTos.forEach((to ) =>{
    $(to).removeAttr('style')
    $(to).css('border-color', '#696969')
    $(to).css('background-image', '')
  })
  }
function duplicateEducationHistory(isNew,eduHistory){
  //Boostrap from validation - duplicateEducationHistory reset form validation **begin
  const formElement = document.querySelector("#applicationForm")
  formElement.classList.remove("was-validated");
  //Boostrap from validation - reset form validation **end

  var original = document.getElementById('previousEducation-0');
  var clone = original.cloneNode(true); // "deep" clone
  clone.id = "previousEducation-" + ++educationCounter; // there can only be one element with an ID
  clone.children[1].children[1].children[0].id = "removePreviousEducation-" + educationCounter;
  if(isNew){
    clone.elements["edErecruitId"].value = null
    clone.elements['educationLevel'].value = ''
    clone.elements["schoolName"].value = ''
    clone.elements['courseOfStudy'].value = ''
    clone.elements['yearsCompleted'].value = ''
    for(var i = 0; i < clone.elements.length; i++){
      clone.elements[i].disabled = false
    }
    clone.children[1].children[1].style.display = "block"
  } else {
    clone.elements["edErecruitId"].value = eduHistory['edErecruitId'] !== undefined && eduHistory['edErecruitId'] !== '' ? eduHistory['edErecruitId'] : ''
    clone.elements['educationLevel'].value = eduHistory['educationLevelId'] !== undefined && eduHistory['educationLevelId'] !== '' ? eduHistory['educationLevelId'] : ''
    clone.elements["schoolName"].value = eduHistory['schoolName'] !== undefined && eduHistory['schoolName'] !== '' ? eduHistory['schoolName'] : ''
    clone.elements['courseOfStudy'].value = eduHistory['courseOfStudy'] !== undefined && eduHistory['courseOfStudy'] !== '' ? eduHistory['courseOfStudy'] : ''
    clone.elements['yearsCompleted'].value = eduHistory['yearsCompleted'] !== undefined && eduHistory['yearsCompleted'] !== '' ? eduHistory['yearsCompleted'] : ''
    clone.children[1].children[1].style.display = "none"
  }
  console.log(' edErecruitId: ' + clone.elements["edErecruitId"].value)
  educationHistory.push(clone.elements);
  document.getElementById('educationHistoryBody').append(clone);

  const jobFroms = document.querySelectorAll("input[name='jobFrom']")
  jobFroms.forEach((from ) =>{
    $(from).removeAttr('style')
    $(from).css('border-color', '#696969')
    $(from).css('background-image', '')
  })
  const jobTos = document.querySelectorAll("input[name='jobTo']")
  jobTos.forEach((to ) =>{
    $(to).removeAttr('style')
    $(to).css('border-color', '#696969')
    $(to).css('background-image', '')
  })
}

function deleteWorkClone(event){
  var index = event.currentTarget.id.split('-')[1]
  var wrkItem = document.getElementById('previousEmployer-' + index)
  wrkItem.remove();
  wrkHistory.splice(index,1)
}

function deleteSchoolClone(event){
  var index = event.currentTarget.id.split('-')[1]
  var edItem = document.getElementById('previousEducation-' + index)
  edItem.remove();
  educationHistory.splice(index, 1)
}

function validate(event){
  if(event.currentTarget.value !== ''){
    //  if (event.currentTarget.id === 'jobFrom' || event.currentTarget.id === 'jobTo'){
    if (event.currentTarget.id.includes('jobFrom') || event.currentTarget.id.includes('jobTo')){
      var curchr = event.currentTarget.value.length;
      var curval = event.currentTarget.value;
      console.log('curchr ' + curchr)
      console.log('curval ' + curval)
      if (curchr === 2 && event.key !== 'Backspace') {
        if(curval.at(1) === '/'){
          curval = 0 + curval.at(0)
          event.currentTarget.value = curval + "/";
        }
        else
        {
          event.currentTarget.value = curval + "/";
        }
      }
    }
  }else{
    if (event.type !== 'keyup'){
    //  event.currentTarget.setAttribute('style', 'background: pink')
    }
  }
}

$('#jobFrom').change(function (event) {
  validateFromDate(event)
});

$('#jobTo').change(function (event) {
  validateToDate(event)
});

function validateFromDate(event){
  let fromDate = event.currentTarget.value
  let fromDateId = event.currentTarget.id
  let $fromDate = $('#' + fromDateId)
  let $jobFromMsg, $jobToMsg, $toDate, toDate
  let idx = fromDateId.indexOf("-")
  if (idx > 0) {
    idx = fromDateId.substring(idx + 1)
    $jobFromMsg = $('#jobFromMsg-' + idx)
    $jobToMsg = $('#jobToMsg-' + idx)
    $toDate = $('#jobTo-' + idx)
  }else{
    $jobFromMsg = $('#jobFromMsg')
    $jobToMsg = $('#jobToMsg')
    $toDate = $('#jobTo')
  }
  toDate = $toDate.val()
  if (fromDate !== '') {
    let retCode = validateJobDate($fromDate)
    if (retCode === 0) {
      if (toDate !== '' && validateJobDate($toDate) === 0) {
        if (compareJobDates(fromDate, toDate)) {
          $jobFromMsg.css('display', 'none');
          $jobToMsg.css('display', 'none');
          $fromDate.removeClass('invalidJobDate')
          $toDate.removeClass('invalidJobDate')
          if ($("#applicationForm").hasClass("was-validated")) {
            $fromDate.css('border-color', 'rgb(13, 110, 253)');
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $toDate.css('border-color', 'rgb(13, 110, 253)');
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $toDate.css('box-shadow', '');
          }
        }else {
          $jobFromMsg.text('From date is greater than to date')
          $jobFromMsg.css("display", "block")
          $fromDate.addClass('invalidJobDate')
          if ($("#applicationForm").hasClass("was-validated")) {
            $fromDate.css('border-color', '#dc3545')
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
          }
        }
      }
        if (!$fromDate.hasClass("invalidJobDate")) {
          $jobFromMsg.css('display', 'none');
          if ($("#applicationForm").hasClass("was-validated")) {
            $fromDate.removeAttr('style')
            $fromDate.css('border-color', 'rgb(13, 110, 253)');
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
          }
        }
    } else {
      if ($("#applicationForm").hasClass("was-validated")) {
        $fromDate.css('border-color', '#dc3545')
        $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
      }
      $jobFromMsg.text('Invalid from date')
      if (retCode === 2)
        $jobFromMsg.text('From date is greater than current date')
      $jobFromMsg.css("display", "block")
      event.currentTarget.select();
    }
  } else {
    $jobFromMsg.text('Please enter from date')
    $jobFromMsg.css("display", "block")
  }
}

function validateToDate(event) {
  let toDate = event.currentTarget.value
  let toDateId = event.currentTarget.id
  let $toDate = $('#' + toDateId)
  let $jobFromMsg, $jobToMsg, $fromDate, fromDate
  let idx = toDateId.indexOf("-")
  if (idx > 0) {
    idx = toDateId.substring(idx + 1)
    $jobFromMsg = $('#jobFromMsg-' + idx)
    $jobToMsg = $('#jobToMsg-' + idx)
    $fromDate = $('#jobFrom-' + idx)
  }else{
    $jobFromMsg = $('#jobFromMsg')
    $jobToMsg = $('#jobToMsg')
    $fromDate = $('#jobFrom')
  }
  fromDate = $fromDate.val()
  if (toDate !== '') {
    let retCode = validateJobDate($toDate)
    if (retCode === 0) {
      if (fromDate !== '' && validateJobDate($fromDate) === 0) {
        if (compareJobDates(fromDate, toDate)) {
          $jobToMsg.css('display', 'none');
          $toDate.removeClass('invalidJobDate')
          if (validateJobDate($fromDate) === 0) {
            $jobFromMsg.css('display', 'none');
            $fromDate.removeClass('invalidJobDate')
          }
          if ($("#applicationForm").hasClass("was-validated")) {
            $toDate.css('border-color', 'rgb(13, 110, 253)');
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $fromDate.css('border-color', 'rgb(13, 110, 253)');
            $fromDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
            $fromDate.css('box-shadow', '');
          }
        } else {
          $jobToMsg.text('To date is less than from date')
          $jobToMsg.css("display", "block")
          $toDate.addClass('invalidJobDate')
          if (document.querySelector("#applicationForm").classList.contains("was-validated")) {
            $toDate.css('border-color', '#dc3545')
            $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
          }
        }
      }
      if (!$toDate.hasClass("invalidJobDate")) {
        $jobToMsg.css('display', 'none');
        if ($("#applicationForm").hasClass("was-validated")) {
          $toDate.removeAttr('style')
          $toDate.css('border-color', 'rgb(13, 110, 253)');
          $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")")
        }
      }
    } else {
        if ($("#applicationForm").hasClass("was-validated")) {
          $toDate.css('border-color', '#dc3545')
          $toDate.css('background-image', "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5' /%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z' /%3e%3ccircle cx='6' cy='8.2' r='.6' stroke='none' fill='%23dc3545' /%3e%3c/svg%3e\")")
        }
        $jobToMsg.text('Invalid to date')
        if (retCode === 2)
          $jobToMsg.text('To date is greater than current date')
        $jobToMsg.css("display", "block")
      event.currentTarget.select();
    }
  } else {
      $jobToMsg.text('Please enter to date')
      $jobToMsg.css("display", "block")
  }
}

function validateJobDate($jobDate){
  let jobDate = $jobDate.val()
  let pattern = $('#jobFrom').attr("pattern")
  let regex = new RegExp(pattern)
  if (!regex.test(jobDate))
      return 1
  let jobMonthYear = jobDate.split("/")
  let jobMonth = Number(jobMonthYear[0])
  let jobYear = Number(jobMonthYear[1])
  let currDate = new Date();
  let currMonth = currDate.getMonth() + 1
  let currYear = currDate.getFullYear()
  if ((jobYear === currYear && (jobMonth > currMonth)) || (jobYear > currYear)) {
    $jobDate.addClass('invalidJobDate')
    return 2
  }
  else {
    $jobDate.removeClass('invalidJobDate')
    return 0
  }
}
function compareJobDates(fromDate, toDate){
  let fromMonthYear = fromDate.split("/")
  let fromMonth = Number(fromMonthYear[0])
  let fromYear = Number(fromMonthYear[1])
  let toMonthYear = toDate.split("/")
  let toMonth = Number(toMonthYear[0])
  let toYear = Number(toMonthYear[1])
  if ((fromYear === toYear && (fromMonth > toMonth)) || (fromYear > toYear))
    return false
  else
    return true
}

function checkEligibilityInput(event){
  if ( $('#noUsAuthorized').is(":checked")){
    $('#authorizedWarning').show();
  } else {
    $('#authorizedWarning').hide();
  }
  if($("input[name='ageVerification-radio-group']:checked").val() !== undefined
   //  && $("input[name='usAuthorizationVerification-radio-group2']:checked").val() !== undefined
     && $("#UsAuthorized").is(":checked")
     && $('#emailAddress')[0].validity.valid){
    $("#part1Continue").prop('disabled',false);
  } else {
    $("#part1Continue").prop('disabled',true);
  }

  if ($("#eligibilityMsg").is(":visible") && $('#emailAddress')[0].validity.valid) {
      $('#eligibilityMsg').text('')
      $('#eligibilityMsg').hide();
      $('#emailAddress').css('background-color', 'white')
  }
}
document.addEventListener("keypress", function(event) {
  if (event.key === "Enter") {
    event.preventDefault();
  }
});

function showSponsorshipInfo() {
  $("#sponsorshipInfo").modal("show");
};
function hideSponsorshipInfo() {
  $("#sponsorshipInfo").modal("hide");
};
